/**
 * Collection gender toggles — filter by product.type.
 * Nav stays hidden until product-type counts are confirmed (no flash of empty genders).
 */
(function () {
  if (document.documentElement.dataset.platiniCollectionGenderFilter) return;
  document.documentElement.dataset.platiniCollectionGenderFilter = 'true';

  var PARAM = 'gender';
  var fillToken = 0;
  var currentGender = '';
  var typeCounts = null;
  var countsReady = false;

  window.PlatiniGenderFilter = window.PlatiniGenderFilter || {};
  window.PlatiniGenderFilter.getActive = function () {
    return currentGender;
  };
  window.PlatiniGenderFilter.isBusy = function () {
    return window.PlatiniGenderFilter._busy === true;
  };
  window.PlatiniGenderFilter.set = function (value) {
    applyGenderFilter(value || '');
  };

  function getNav() {
    return document.querySelector('[data-collection-gender-toggles]');
  }

  function getGrid() {
    return document.getElementById('product-grid');
  }

  function normalize(value) {
    return String(value || '')
      .trim()
      .toLowerCase()
      .replace(/['’]/g, '');
  }

  function genderKey(value) {
    var v = normalize(value);
    if (!v) return '';
    if (v === 'men' || v === 'man' || v === 'mens' || v === 'male') return 'men';
    if (v === 'women' || v === 'woman' || v === 'womens' || v === 'female' || v === 'ladies') return 'women';
    if (v === 'kids' || v === 'kid' || v === 'boys' || v === 'boy' || v === 'girls' || v === 'girl' || v === 'youth') {
      return 'kids';
    }
    if (v === 'unisex') return 'unisex';
    return v;
  }

  function typesMatch(a, b) {
    if (!b) return true;
    return genderKey(a) === genderKey(b);
  }

  function readUrlGender() {
    var params = new URLSearchParams(window.location.search);
    return params.get(PARAM) || '';
  }

  function setUrlGender(value) {
    var url = new URL(window.location.href);
    if (value) url.searchParams.set(PARAM, value);
    else url.searchParams.delete(PARAM);
    url.searchParams.delete('filter.p.product_type');
    var next = url.pathname + url.search + url.hash;
    if (next !== window.location.pathname + window.location.search + window.location.hash) {
      history.replaceState(history.state, '', next);
    }
  }

  function setActiveButton(value) {
    var nav = getNav();
    if (!nav) return;
    var target = genderKey(value);
    nav.querySelectorAll('[data-gender-value]').forEach(function (btn) {
      var match = genderKey(btn.getAttribute('data-gender-value')) === target;
      btn.classList.toggle('is-active', match);
      btn.setAttribute('aria-pressed', match ? 'true' : 'false');
    });
  }

  function applyVisibility(value) {
    var grid = getGrid();
    if (!grid) return 0;
    var visible = 0;
    grid.querySelectorAll(':scope > li.grid__item').forEach(function (li) {
      var type = li.getAttribute('data-product-type');
      var show = typesMatch(type, value);
      li.hidden = !show;
      li.style.display = show ? '' : 'none';
      if (show) visible += 1;
    });
    return visible;
  }

  function ensureEmptyState(visible, value) {
    var container = document.getElementById('ProductGridContainer');
    if (!container) return;
    var existing = container.querySelector('[data-gender-empty]');
    if (visible > 0 || !value) {
      if (existing) existing.remove();
      return;
    }
    if (existing) return;
    var msg = document.createElement('div');
    msg.className = 'collection-gender-empty page-width';
    msg.setAttribute('data-gender-empty', 'true');
    msg.innerHTML =
      '<p class="collection-gender-empty__text">No products found for this filter.</p>';
    var gridWrap = container.querySelector('.collection:not(.collection--empty)');
    if (gridWrap) gridWrap.after(msg);
    else container.appendChild(msg);
  }

  function pauseAutoLoadMore() {
    document.documentElement.dataset.platiniPauseCollectionAutoLoad = 'true';
    if (window.PlatiniCollectionLoadMore && typeof window.PlatiniCollectionLoadMore.pause === 'function') {
      window.PlatiniCollectionLoadMore.pause();
    }
  }

  function resumeAutoLoadMore() {
    delete document.documentElement.dataset.platiniPauseCollectionAutoLoad;
    if (window.PlatiniCollectionLoadMore && typeof window.PlatiniCollectionLoadMore.resume === 'function') {
      window.PlatiniCollectionLoadMore.resume();
    }
  }

  function countFromGrid() {
    var counts = {};
    var grid = getGrid();
    if (!grid) return counts;
    grid.querySelectorAll(':scope > li.grid__item[data-product-type]').forEach(function (li) {
      var key = genderKey(li.getAttribute('data-product-type'));
      if (key !== 'men' && key !== 'women' && key !== 'kids' && key !== 'unisex') return;
      counts[key] = (counts[key] || 0) + 1;
    });
    return counts;
  }

  function mergeCounts(a, b) {
    var out = {};
    [a, b].forEach(function (src) {
      if (!src) return;
      Object.keys(src).forEach(function (k) {
        out[k] = Math.max(out[k] || 0, src[k] || 0);
      });
    });
    return out;
  }

  function collectionProductsUrl(page) {
    var path = window.location.pathname.replace(/\/$/, '');
    return path + '/products.json?limit=250&page=' + page;
  }

  function fetchTypeCounts() {
    var counts = {};
    var page = 1;
    var maxPages = 8;

    function next() {
      return fetch(collectionProductsUrl(page), { credentials: 'same-origin' })
        .then(function (res) {
          if (!res.ok) throw new Error('products.json ' + res.status);
          return res.json();
        })
        .then(function (data) {
          var products = (data && data.products) || [];
          products.forEach(function (p) {
            var key = genderKey(p.product_type || '');
            if (key !== 'men' && key !== 'women' && key !== 'kids' && key !== 'unisex') return;
            counts[key] = (counts[key] || 0) + 1;
          });
          if (products.length < 250 || page >= maxPages) return counts;
          page += 1;
          return next();
        });
    }

    return next();
  }

  function syncButtonsToCounts(counts) {
    var nav = getNav();
    if (!nav) return 0;
    var kept = 0;
    nav.querySelectorAll('[data-gender-value]').forEach(function (btn) {
      var raw = btn.getAttribute('data-gender-value');
      if (!raw) return;
      var key = genderKey(raw);
      var count = counts[key] || 0;
      if (count < 1) {
        var item = btn.closest('.collection-gender-toggles__item');
        if (item) item.remove();
        else btn.remove();
        return;
      }
      kept += 1;
    });
    orderGenderButtons(nav);
    return kept;
  }

  /* Keep All → Men → Women → Kids → Unisex after JS prunes empty genders */
  function orderGenderButtons(nav) {
    var list = nav && nav.querySelector('.collection-gender-toggles__list');
    if (!list) return;
    var rank = { '': 0, men: 1, women: 2, kids: 3, unisex: 4 };
    var items = Array.prototype.slice.call(list.children);
    items.sort(function (a, b) {
      var aBtn = a.querySelector('[data-gender-value]');
      var bBtn = b.querySelector('[data-gender-value]');
      var aKey = aBtn ? genderKey(aBtn.getAttribute('data-gender-value')) : '';
      var bKey = bBtn ? genderKey(bBtn.getAttribute('data-gender-value')) : '';
      var aRank = Object.prototype.hasOwnProperty.call(rank, aKey) ? rank[aKey] : 99;
      var bRank = Object.prototype.hasOwnProperty.call(rank, bKey) ? rank[bKey] : 99;
      return aRank - bRank;
    });
    items.forEach(function (item) {
      list.appendChild(item);
    });
  }

  function revealNav(keptGenders) {
    var nav = getNav();
    if (!nav) return;
    nav.removeAttribute('data-gender-pending');
    if (keptGenders >= 2) {
      nav.hidden = false;
      nav.classList.remove('collection-gender-toggles--empty');
    } else {
      nav.hidden = true;
      nav.classList.add('collection-gender-toggles--empty');
    }
  }

  function hideGenderButton(value) {
    var nav = getNav();
    if (!nav || !value) return;
    var key = genderKey(value);
    var kept = 0;
    nav.querySelectorAll('[data-gender-value]').forEach(function (btn) {
      var raw = btn.getAttribute('data-gender-value');
      if (!raw) return;
      if (genderKey(raw) === key) {
        var item = btn.closest('.collection-gender-toggles__item');
        if (item) item.remove();
        else btn.remove();
        return;
      }
      kept += 1;
    });
    revealNav(kept);
  }

  function loadNextPageSilent() {
    var btn = document.querySelector('#ProductGridContainer [data-load-more]');
    if (!btn) return Promise.resolve(false);

    var sectionId = btn.getAttribute('data-section-id');
    var nextPath = btn.getAttribute('data-next-url');
    if (!sectionId || !nextPath) return Promise.resolve(false);

    var wrap = btn.closest('[data-collection-load-more]');
    var url = new URL(nextPath, window.location.href);
    url.searchParams.set('section_id', sectionId);

    return fetch(url.toString())
      .then(function (res) {
        return res.text();
      })
      .then(function (html) {
        var doc = new DOMParser().parseFromString(html, 'text/html');
        var fetched = doc.getElementById('ProductGridContainer');
        var currentGrid = getGrid();
        var newGrid = fetched && fetched.querySelector('#product-grid');
        if (!currentGrid || !newGrid) return false;

        newGrid.querySelectorAll('li.grid__item').forEach(function (li) {
          currentGrid.appendChild(li);
        });

        var newWrap = fetched.querySelector('[data-collection-load-more]');
        var newBtn = newWrap && newWrap.querySelector('[data-load-more]');
        if (wrap) {
          if (newBtn) wrap.innerHTML = newWrap.innerHTML;
          else wrap.remove();
        }
        return true;
      })
      .catch(function () {
        return false;
      });
  }

  function fillMatchingPages(value, token) {
    var minVisible = 8;
    var maxPages = 12;
    var pages = 0;

    window.PlatiniGenderFilter._busy = true;
    pauseAutoLoadMore();

    function finish(visible) {
      window.PlatiniGenderFilter._busy = false;
      if (visible < 1 && value) {
        if (typeCounts) typeCounts[genderKey(value)] = 0;
        hideGenderButton(value);
        applyGenderFilter('');
        return;
      }
      ensureEmptyState(visible, value);
    }

    function step() {
      if (token !== fillToken) {
        window.PlatiniGenderFilter._busy = false;
        return Promise.resolve();
      }

      var visible = applyVisibility(value);
      if (visible >= minVisible || pages >= maxPages) {
        finish(visible);
        return Promise.resolve();
      }

      pages += 1;
      return loadNextPageSilent().then(function (loaded) {
        if (token !== fillToken) {
          window.PlatiniGenderFilter._busy = false;
          return;
        }
        if (!loaded) {
          finish(applyVisibility(value));
          return;
        }
        applyVisibility(value);
        return step();
      });
    }

    return step();
  }

  function applyGenderFilter(value) {
    var next = value || '';
    var prev = currentGender;
    currentGender = next;
    window.PlatiniGenderFilter.active = next;

    var key = genderKey(next) || 'all';
    document.documentElement.dataset.platiniGender = key;

    setActiveButton(next);
    setUrlGender(next);
    var visible = applyVisibility(next);
    ensureEmptyState(visible, next);

    fillToken += 1;
    var token = fillToken;

    document.dispatchEvent(
      new CustomEvent('platini:gender-filter:change', {
        detail: {
          gender: key,
          previous: genderKey(prev) || 'all',
          drivenBySize: document.documentElement.dataset.platiniSizeDrivingGender === '1',
        },
      })
    );

    if (!next) {
      window.PlatiniGenderFilter._busy = false;
      resumeAutoLoadMore();
      return;
    }

    if (countsReady && typeCounts && (typeCounts[genderKey(next)] || 0) < 1) {
      hideGenderButton(next);
      applyGenderFilter('');
      return;
    }

    fillMatchingPages(next, token);
  }

  /* Re-apply after AJAX facet refreshes replace the product grid */
  function patchFacetGridRender() {
    if (typeof FacetFiltersForm === 'undefined' || FacetFiltersForm.__platiniGenderPatched) return;
    var orig = FacetFiltersForm.renderProductGridContainer;
    FacetFiltersForm.renderProductGridContainer = function (html) {
      orig.call(this, html);
      if (currentGender) applyVisibility(currentGender);
      document.dispatchEvent(new CustomEvent('platini:product-grid:updated'));
    };
    FacetFiltersForm.__platiniGenderPatched = true;
  }

  /*
   * Facet AJAX re-renders CollectionGenderToggles from Liquid as hidden +
   * data-gender-pending (and sometimes empty when filtered counts drop).
   * Keep the live nav so tabs never disappear until a full page refresh.
   */
  function patchGenderTogglesRender() {
    if (typeof FacetFiltersForm === 'undefined' || FacetFiltersForm.__platiniGenderTogglesPatched) return;

    FacetFiltersForm.renderGenderToggles = function (html) {
      var current = document.getElementById('CollectionGenderToggles');
      if (!current) return;

      var hasLiveNav =
        current.hasAttribute('data-collection-gender-toggles') &&
        !!current.querySelector('[data-gender-value]');

      if (countsReady && hasLiveNav) {
        current.hidden = false;
        current.removeAttribute('data-gender-pending');
        current.classList.remove('collection-gender-toggles--empty');
        if (typeCounts) syncButtonsToCounts(typeCounts);
        orderGenderButtons(current);
        setActiveButton(currentGender);
        return;
      }

      if (!html) return;
      var parsed = new DOMParser().parseFromString(html, 'text/html');
      var next = parsed.getElementById('CollectionGenderToggles');
      if (!next) return;

      var nextHasNav =
        next.hasAttribute('data-collection-gender-toggles') &&
        !!next.querySelector('[data-gender-value]');

      /* Never replace a working nav with a pending/empty Liquid stub */
      if (hasLiveNav && !nextHasNav) return;

      current.replaceWith(next);
      var nav = document.getElementById('CollectionGenderToggles');
      if (!nav || !countsReady) return;
      if (typeCounts) {
        var kept = syncButtonsToCounts(typeCounts);
        revealNav(kept);
      }
      setActiveButton(currentGender);
    };

    FacetFiltersForm.__platiniGenderTogglesPatched = true;
  }

  patchFacetGridRender();
  patchGenderTogglesRender();
  document.addEventListener('DOMContentLoaded', function () {
    patchFacetGridRender();
    patchGenderTogglesRender();
  });

  document.addEventListener(
    'click',
    function (event) {
      var btn = event.target.closest('[data-collection-gender-toggles] [data-gender-value]');
      if (!btn) return;
      event.preventDefault();
      event.stopPropagation();
      var raw = btn.getAttribute('data-gender-value') || '';
      var next = genderKey(raw);
      /* Clicking the active gender again returns to ALL */
      if (next && next === genderKey(currentGender)) next = '';
      applyGenderFilter(next ? raw : '');
    },
    true
  );

  document.addEventListener('platini:product-grid:updated', function () {
    if (!currentGender) return;
    applyVisibility(currentGender);
    pauseAutoLoadMore();
  });

  function boot() {
    var nav = getNav();
    if (!nav) return;

    // Always start hidden — reveal only after counts are known
    nav.hidden = true;
    nav.setAttribute('data-gender-pending', 'true');

    var gridCounts = countFromGrid();

    fetchTypeCounts()
      .then(function (remoteCounts) {
        typeCounts = mergeCounts(gridCounts, remoteCounts);
        countsReady = true;
        var kept = syncButtonsToCounts(typeCounts);
        revealNav(kept);

        var initial = readUrlGender();
        if (initial && (typeCounts[genderKey(initial)] || 0) < 1) {
          applyGenderFilter('');
          return;
        }
        if (initial) applyGenderFilter(initial);
        else {
          currentGender = '';
          document.documentElement.dataset.platiniGender = 'all';
          setActiveButton('');
        }
      })
      .catch(function () {
        // Fetch failed — fall back to what is already on the grid only
        typeCounts = gridCounts;
        countsReady = true;
        var kept = Object.keys(gridCounts).filter(function (k) {
          return gridCounts[k] > 0;
        }).length;
        if (kept >= 2) {
          syncButtonsToCounts(gridCounts);
          revealNav(kept);
        } else {
          // Keep Liquid buttons visible rather than wiping the bar on a network blip
          revealNav(
            nav.querySelectorAll('[data-gender-value]:not([data-gender-value=""])').length
          );
        }
        var initial = readUrlGender();
        if (initial) applyGenderFilter(initial);
        else setActiveButton('');
      });
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', boot);
  } else {
    boot();
  }
})();
